/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2020-04-17 17:26:05
 * @Description: 封装el-form
 */

import ApexForm from './src/index'

ApexForm.install = function(Vue) {
  Vue.component(ApexForm.name, ApexForm)
}

export default ApexForm
